var _rect, _rect2, _rect3, _rect4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompressedNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 33,
    viewBox: "0 0 47 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.85938,
    y: 7.99805,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.85938,
    y: 12.3027,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.85938,
    y: 16.6055,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.85938,
    y: 20.9121,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63281 16.0691L5.18608 13.3788L2.07955 13.3788L3.63281 16.0691ZM3.36378 9.07422L3.36378 13.6478L3.90185 13.6478L3.90185 9.07422L3.36378 9.07422Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63281 16.6067L2.07955 19.297H5.18608L3.63281 16.6067ZM3.90185 23.6016L3.90185 19.028H3.36378L3.36378 23.6016H3.90185Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompressedNew);
export default __webpack_public_path__ + "static/media/Compressed_New.2d4d366c1e6fe8f9a18a6b806ede8a38.svg";
export { ForwardRef as ReactComponent };